import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import {Tr} from "@/i18n/i18n";
import CU from "../utils/c-u";

export class ClanAboutControlPanel extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, defaultCallback: () => unknown, editCallback: () => unknown) {
        super(scene);

        this.scene = scene;
        this.width = CU.CANVAS_WIDTH;
        this.height = 200;

        let defaultButton = new SquareButton(this.scene, 200, 100, 0, Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, Tr('init.txt'), false);
        defaultButton.setCallback(() => {
            defaultCallback();
        });
        this.add(defaultButton);

        let editButton = new SquareButton(this.scene, 400, 100, 0, Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('edit'), false);
        editButton.setCallback(() => {
            editCallback();
        });
        this.add(editButton);
    }

}
